import React from "react";
import { Container, Paper, Stack, Title, Text } from "@mantine/core";
import { MantineProvider } from "@mantine/core";
import { IconArrowsLeftRight } from "@tabler/icons-react";
import TransportLocalRequestStepper from "./TransportLocalRequestStepper";

export default function TransportLocalRequestPage() {
    return (
        <Container size="md" py="xl">
            <Paper withBorder p="lg" radius="md">
                <Stack gap="xs">
                    <Title order={3}>
                        <IconArrowsLeftRight size={25} /> Transport Local request
                    </Title>
                    <Text c="dimmed">
                        Fill in your local transport and contact information - and we will register your transport.
                    </Text>
                </Stack>
            </Paper>

            <Paper withBorder p="lg" radius="md" mt="md">
                <MantineProvider
                    theme={{
                        primaryColor: "brand",
                        colors: {
                            brand: [
                                "#ffe5e5",
                                "#ffcaca",
                                "#ff9a9a",
                                "#ff7a7a",
                                "#ff6868",
                                "#ff5e5e",
                                "#f24848",
                                "#e53a3a",
                                "#d92d2d",
                                "#cc2222",
                            ],
                        },
                    }}
                >
                    <TransportLocalRequestStepper />
                </MantineProvider>
            </Paper>
        </Container>
    );
}